// ホールディングス案件一覧表のラベル
export const LABELS = {
  TITLE: "ホールディングス案件一覧",
  HOLDINGS_LEAD_NEW_ENTRY: "案件新規登録",
  HOLDINGS_NEW_ENTRY: "　新規登録　",
  HOLDINGS_CORPORATE_NUMBER: "法人番号",
  HOLDINGS_COMPANY_CODE: "事業者コード",
  HOLDINGS_COMPANY_NAME: "事業者名",
} as const;
